import createSingleTileImageLayer from '~app/core/createSingleTileImageLayer';

export const CLEAR_LOW_RES_LAYERS = 'CLEAR_LOW_RES_LAYERS';
export const CACHE_LOW_RES_LAYERS = 'CACHE_LOW_RES_LAYERS';

export const SET_ACTIVE_LAYER_INDEX = 'SET_ACTIVE_LAYER_INDEX';
export const SET_MAP_INDEX = 'SET_MAP_INDEX';

export const SET_HIGH_RES = 'SET_HIGH_RES';

// Init

export function clearLowResLayers() {
  return {
    type: CLEAR_LOW_RES_LAYERS,
  };
}

export function loadLowResLayers(updateProgress) {
  return (dispatch, getState) => {
    const layers = getState().layer.layers;

    // This generates an array of arrays of low-res layers.
    // For each layer def (eg. Temp, Precip):
    const lowResLayers = layers.map(layerDef =>
      // For each map (frame) in the layer def:
      layerDef.maps.map(mapDef => {
        // Create the low-res image.
        const layer = createSingleTileImageLayer(`single_tiles/low_res/${mapDef.name}-lowres`);
        updateProgress();
        return layer;
      })
    );

    dispatch({
      type: CACHE_LOW_RES_LAYERS,
      layers: lowResLayers,
    });
  };
}

export function countLowResLayers(state) {
  const layers = state.layer.layers;

  // Count our workload.
  let totalMaps = 0;
  layers.forEach(layerDef => totalMaps += layerDef.maps.length);
  return totalMaps;
}

// Layers

export function cycleLayerLeft() {
  return (dispatch, getState) => {
    const currentLayerIndex = getState().layer.activeLayerIndex;
    const nextLayerIndex = (currentLayerIndex > 0) ?
                              (currentLayerIndex - 1) :
                              (getState().layer.layers.length - 1);

    dispatch({
      type: SET_ACTIVE_LAYER_INDEX,
      index: nextLayerIndex,
    });
  };
}

export function cycleLayerRight() {
  return (dispatch, getState) => {
    const currentLayerIndex = getState().layer.activeLayerIndex;
    const nextLayerIndex = (currentLayerIndex < getState().layer.layers.length - 1) ?
                              (currentLayerIndex + 1) :
                              (0);

    dispatch({
      type: SET_ACTIVE_LAYER_INDEX,
      index: nextLayerIndex,
    });
  };
}

// Frames

export function setMapIndex(mapIndex) {
  return {
    type: SET_MAP_INDEX,
    index: mapIndex,
  };
}

// Settings

export function showHighRes(enabled) {
  return {
    type: SET_HIGH_RES,
    enabled,
  };
}



// WEBPACK FOOTER //
// ./src/actions/layers.js